import { Controller } from '@hotwired/stimulus'

// Reloads the enclosing turbo-frame when an ActionCable stream source connects.
// Fixes the subscribe race: if the job finishes before the WebSocket handshake
// completes, the "in progress" alert never receives the completion broadcast.
// turbo-cable-stream-source gains a `connected` attribute once ActionCable is ready —
// we observe that mutation and reload the frame to fetch current state.
export default class extends Controller {
  connect() {
    const sources = document.querySelectorAll('turbo-cable-stream-source')

    if (Array.from(sources).some(el => el.hasAttribute('connected'))) {
      this.reloadFrame()
      return
    }

    this.observer = new MutationObserver((mutations) => {
      if (mutations.some(m => m.attributeName === 'connected' && m.target.hasAttribute('connected'))) {
        this.reloadFrame()
        this.observer.disconnect()
      }
    })

    sources.forEach(el => this.observer.observe(el, { attributes: true, attributeFilter: ['connected'] }))
  }

  disconnect() {
    this.observer?.disconnect()
  }

  reloadFrame() {
    this.element.closest('turbo-frame')?.reload()
  }
}
